import { z } from 'zod';

export const ruleParamsSchema = z.object({
  ruleId: z.coerce.number(),
});

export type RuleParams = z.infer<typeof ruleParamsSchema>;
